import { shirt } from "./shirt.css";
import { ShirtProps } from "./types";

const Shirt = ({ alt, path, sizes }: ShirtProps) => (
  <picture>
    <source
      type="image/webp"
      srcSet={`
        ${path}-66.webp 66w,
        ${path}-110.webp 110w,
        ${path}-220.webp 220w
        `}
      sizes={sizes}
    />
    <img
      className={shirt}
      src={`${path}-66.png`}
      srcSet={`
        ${path}-66.png 66w,
        ${path}-110.png 110w,
        ${path}-220.png 220w
        `}
      sizes={sizes}
      alt={alt}
      role={alt === "" ? "presentation" : undefined}
    />
  </picture>
);

export default Shirt;
